import { render, staticRenderFns } from "./Delegates.vue?vue&type=template&id=5c8d6ae1&scoped=true&"
import script from "./Delegates.vue?vue&type=script&lang=js&"
export * from "./Delegates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c8d6ae1",
  null
  
)

export default component.exports